enum EnumPartnerType {
	MainPage = 0,
	SecondPage = 1
}
export default EnumPartnerType



// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/DataModels/Enums/EnumPartnerType.ts